import { User } from "../types";

export const getUserInitials = (user: User) =>
  [user.Firstname, user.Lastname].map((value) => value.substr(0, 1)).join("");
